module.exports = __webpack_public_path__ + "img/grant-thornton-logo.9621f641.jpg";